import { render, staticRenderFns } from "./BssWrite.vue?vue&type=template&id=5b61ce2a&scoped=true"
import script from "./BssWrite.vue?vue&type=script&lang=js"
export * from "./BssWrite.vue?vue&type=script&lang=js"
import style0 from "./BssWrite.vue?vue&type=style&index=0&id=5b61ce2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61ce2a",
  null
  
)

export default component.exports